import { makeStyles } from '@material-ui/core';
import { FORM_FIELD_HEIGHT } from '../../../TransactionsMonitoring/components/Filters/components/common_styles';

export default makeStyles((theme) => ({
  stickyContainer: {
    position: 'sticky',
    background: '#fafafa',
    width: '100%',
    top: 0,
    marginLeft: 12,
    marginRight: 12,
    zIndex: 3,
    display: 'none',
    boxSizing: 'border-box',

    '& > div': {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      boxSizing: 'border-box',
      flexWrap: 'wrap',
      maxWidth: 1320,
      margin: '0 auto',
      boxShadow: '0px 2px 15px 0px rgba(0,0,0, 0.25)',
      padding: '10px 20px',

      [theme.breakpoints.only('sm')]: {
        padding: '10px 16px',
      },

      [theme.breakpoints.only('xs')]: {
        padding: '4px 16px',
      },

      ['@media (max-height:500px)']: {
        minHeight: 'auto',
        padding: '4px 16px',
      }
    }
  },
  timeFrameContainer: {
    maxWidth: 460,
    minWidth: 270,
    [theme.breakpoints.only('sm')]: {
      minWidth: 250
    },
    [theme.breakpoints.only('xs')]: {
      minWidth: 'auto',
      maxWidth: 'none'
    },
  },
  portfoliosContainer: {
    minWidth: 270,
    [theme.breakpoints.only('xs')]: {
      minWidth: 'auto'
    },
  },
  benchmarkButtonContainer: {
    margin: '10px 0',
  },
  benchmarkButton: {
    fontSize: 16,
    fontFamily: 'Roboto-Medium',
    borderRadius: 2,
    boxShadow: 'none',
    textTransform: 'none',

    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
  },
  hidden: {
    visibility: 'hidden'
  },
  buttonRoot: {
    height: FORM_FIELD_HEIGHT,

    [theme.breakpoints.down('sm')]: {
      height: 35,
    },

    [theme.breakpoints.only("xs")]: {
      width: '100%'
    }
  },
  includeHistoricalSwitch:{

  },
  includeHistoricalSwitchLabel: {
    color: '#4D4F5C',
    fontSize: 14,
    fontFamily: 'Roboto-Bold',
    margin: 0,
    [theme.breakpoints.only('sm')]: {
      fontSize: 13
    },

    [theme.breakpoints.only('xs')]: {
      fontSize: 12
    },
  },
  mobileExpansionPanel: {
    position: "absolute",
    bottom: -20,
    background: theme.palette.primary.main,
    borderRadius: "50%",

    '& button[class*="MuiIconButton-root"]': {
      color: '#fff',
    }
  },
  iconBtnRoot: {
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
      padding: 7
    },
  },
  collapseWrapper: {
    width: '100%',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  }
}))
